import { createStyles, makeStyles } from '@material-ui/core/styles';

import { colors } from '../../styles';

export const useStyles = makeStyles((theme: any) =>
  createStyles({
    button: {
      alignSelf: 'center',
      color: colors.textGrey3e,
      marginTop: '10px',
      width: '55%',
      zIndex: 12,
    },
    currentView: {
      alignItems: 'center',
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      justifyContent: 'center',
    },
    homeView: {
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
      width: '100vw',
    },
    homeContent: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      justifyContent: 'center',
      padding: '100px 2vw',
    },
    menuBox: {
      display: 'flex',
      elevation: 1,
      flexDirection: 'row',
      height: '100%',
      padding: theme.spacing(2),
    },
    menuBoxCenter: {
      display: 'flex',
      elevation: 1,
      flexDirection: 'row',
      height: '100%',
      padding: theme.spacing(2),
    },
    menuBoxImage: {
      width: '100%',
    },
    menuBoxItem: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      width: '35%',
    },
    menuBoxItemRight: {
      justifyContent: 'center',
      display: 'flex',
      flexDirection: 'column',
      width: '65%',
    },
    menuBoxTitle: {
      fontFamily: 'Montserrat',
      fontSize: '1.2rem',
      fontWeight: 'bold',
      margin: '0 0 1vh',
      textAlign: 'center',
      textTransform: 'uppercase',
    },
    menuBoxTitleRight: {
      fontFamily: 'Montserrat',
      fontSize: '0.75rem',
      fontWeight: 'bold',
      marginBottom: '10px',
      textAlign: 'center',
    },
    newView: {
      alignItems: 'center',
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      height: '20vh',
      justifyContent: 'center',
      margin: '60px 0',
      width: '100%',
    },
    nothingHere: {
      alignSelf: 'center',
      fontSize: '1em',
      textTransform: 'none',
      [theme.breakpoints.down('768')]: {
        textAlign: 'center',
      },
    },
    slackButton: {
      width: '10vw',
      margin: '0 3vw',
      minWidth: 160,
    },
    soonText: {
      alignSelf: 'center',
      color: colors.textGrey3e,
      fontFamily: 'Montserrat',
      fontSize: '1.2em',
      fontWeight: 'bold',
      textAlign: 'center',
      width: '80%',
    },
    title: {
      fontFamily: 'Montserrat',
      fontSize: '1.4em',
      fontWeight: 'bold',
      margin: '3vh 0',
      textAlign: 'center',
      textTransform: 'uppercase',
      [theme.breakpoints.down('768')]: {
        textAlign: 'center',
      },
    },
    warning: {
      fontSize: '1em',
      margin: '-2vh 0 3vh 0',
      textTransform: 'none',
      [theme.breakpoints.down('768')]: {
        textAlign: 'center',
      },
    },
    workspacesView: {
      display: 'flex',
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2vh 1vw',
      [theme.breakpoints.down('768')]: {
        width: '100%',
        overflowY: 'hidden',
        overflowX: 'scroll',
        justifyContent: 'flex-start',
      },
    },
    noElements: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
    },
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      maxWidth: 450,
      padding: theme.spacing(2, 4, 3),
      position: 'absolute',
      width: '80%',
    },
    modalText: {
      alignSelf: 'center',
      color: colors.textGrey3e,
      fontFamily: 'Montserrat',
      fontSize: '1.2em',
      fontWeight: 'bold',
      textAlign: 'center',
    },
    modalTextContact: {
      alignSelf: 'center',
      color: colors.textGrey3e,
      fontFamily: 'Montserrat',
      fontSize: '1em',
      textAlign: 'center',
    },
  })
);
